<template>
  <div>
    <Header />
    <v-container>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
          <v-alert type="error" v-if="error">{{ error }}</v-alert>
          <v-card :loading="loading">
            <v-container>
              <v-card-title>Neue Quartalsabrechnung</v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <p>
                        Füllen Sie bitte alle Felder aus, um eine neue Quartalsabrechnung zu erstellen.
                      </p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="3">
                      <v-card>
                        <v-card-text>
                          <div>
                            Start Datum:
                            {{ invoice.invoice_start_date | moment("DD.MM.YYYY") }}
                          </div>
                          <div>
                            End Datum:
                            {{ invoice.invoice_end_date | moment("DD.MM.YYYY") }}
                          </div>
                          <div>
                            <h2>
                              Betrag: {{ (invoice.invoice_total / 100).toFixed(2) }} €
                            </h2>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="selectedQuarter"
                        :items="quarters"
                        label="Abrechnungsquartal"/>

                        <v-text-field
                          v-model="invoice.invoice_name"
                          label="Abrechnungsname"
                          placeholder="Rechnungsname" />

                      <v-select
                        v-model="selectedCustomer"
                        :items="getCustomers()"
                        label="Kunde"
                        item-text="customer_name"
                        item-value="customer_id"
                        @change="customerChanged()"/>
                    </v-col>

                    <v-col offset="6" v-if="selectedInvoices.length > 0">
                      <v-btn class="primary" @click="save">
                        <v-icon>mdi-content-save</v-icon>Quartalsrechnung erzeugen
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="searchTerm"
                        placeholder="Suche"
                      >
                      </v-text-field>
                    
                      <v-data-table
                        v-if="invoices"
                        :headers="invoiceHeaders"
                        :items="filterInvoices()"
                        :sort-by="['invoice_start_date']"
                        :search="searchTerm"
                        class="elevation-1"
                        v-model="selectedInvoices"
                        :disable-pagination="true"
                        hide-default-footer
                        item-key="invoice_id"
                        show-select
                        @change="generateInvoiceName()"
                      >
                        <template v-slot:item.invoice_start_date="{ item }">
                          <span>{{
                            item.invoice_start_date | moment("DD.MM.YYYY")
                          }}</span>
                        </template>
                        <template v-slot:item.invoice_end_date="{ item }">
                          <span>{{
                            item.invoice_end_date | moment("DD.MM.YYYY")
                          }}</span>
                        </template>

                        <template v-slot:item.original_total="{ item }">
                          <span>{{ (item.original_total / 100).toFixed(2) }} €</span>
                        </template>

                        <template v-slot:item.total_shipping="{ item }">
                          <span>{{ (item.total_shipping / 100).toFixed(2) }} €</span>
                        </template>

                        <template v-slot:item.acd_total="{ item }">
                          <span>{{ (item.acd_total / 100).toFixed(2) }} €</span>
                        </template>

                        <template v-slot:item.difference="{ item }">
                          <span>{{ (item.difference / 100).toFixed(2) }} €</span>
                        </template>

                     
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Header from "@/views/general/header";
import router from "@/plugins/router";
import CustomersService from "@/services/CustomerService";

export default {
  name: "dashboard",
  components: {
    Header: Header,
  },
  data: () => ({
    loading: true,
    error: null,
    invoices: [], // Initialisiert als leeres Array
    searchTerm: null,
    selectedInvoices: [],
    invoice: {
      invoice_name: null,
      invoice_start_date: null,
      invoice_end_date: null,
      invoice_total: 0,
      invoice_state: "unpaid",
      invoice_items: [], // Neues Feld für individuelle Totals
    },
    invoiceHeaders: [
      { text: "Rechnungs-ID", value: "invoice_id" },
      { text: "Rechnungsname", value: "invoice_name" },
      { text: "Start Datum", value: "invoice_start_date" },
      { text: "End Datum", value: "invoice_end_date" },
      { text: "Rechnungsbetrag", value: "original_total" },
      { text: "Versandkosten", value: "total_shipping" },
      { text: "ACD Betrag", value: "acd_total" },
      { text: "Marge", value: "difference" },
      { text: "Kunde", value: "customer_name" },
    ],
    selectedQuarter: null,
    selectedCustomer: null,
    quarters: [
      { text: "Q1", value: 1 },
      { text: "Q2", value: 2 },
      { text: "Q3", value: 3 },
      { text: "Q4", value: 4 }
    ]
  }),
  mounted() {
    this.refresh();
  },
  watch: {
    selectedInvoices: {
      deep: true,
      handler() {
        this.generateInvoiceData();
      },
    },
  },
  methods: {
    customerChanged() {
      if (!Array.isArray(this.invoices)) {
        console.error('this.invoices is not an array');
        return;
      }

      this.invoice.invoice_name = this.generateInvoiceName();
      let invoices = [...this.invoices];
      this.invoices = [];
      this.$nextTick(() => {
        this.invoices = invoices;
      });
    },
    filterInvoices() {
      if (!Array.isArray(this.invoices)) {
        console.error('this.invoices is not an array');
        return [];
      }
      let invoices = this.invoices;

      if (this.selectedQuarter != null) {
        invoices = invoices.filter((i) => {
          let date = new Date(i.invoice_start_date);
          let month = date.getMonth() + 1;
          return Math.ceil(month / 3) === this.selectedQuarter;
        });
      }

      if (this.selectedCustomer != null) {
        invoices = invoices.filter((i) => i.customer_id === this.selectedCustomer);
      }

      return invoices;
    },

    getCustomers() {
      if (!Array.isArray(this.invoices)) {
        console.error('this.invoices is not an array');
        return [];
      }
      let customers = [];

      for (let i of this.invoices) {
        if (!customers.some(c => c.customer_id === i.customer_id)) {
          customers.push({
            customer_id: i.customer_id,
            customer_name: i.customer_name
          });
        }
      }
      return customers;
    },

    
    generateInvoiceData() {
      if (this.selectedInvoices.length == 0) {
        this.invoice.invoice_start_date = null;
        this.invoice.invoice_end_date = null;
        this.invoice.invoice_total = 0;
        this.invoice.invoice_items = [];
        return;
      }

      this.invoice.invoice_start_date = this.selectedInvoices
        .reduce((min, i) => new Date(i.invoice_start_date) < new Date(min.invoice_start_date) ? i : min).invoice_start_date;
      this.invoice.invoice_end_date = this.selectedInvoices
        .reduce((max, i) => new Date(i.invoice_end_date) > new Date(max.invoice_end_date) ? i : max).invoice_end_date;
      this.invoice.invoice_total = this.selectedInvoices
        .reduce((sum, i) => sum + i.acd_total, 0);

      // Speichern der individuellen Totals
      this.invoice.invoice_items = this.selectedInvoices.map(i => ({
        invoice_id: i.invoice_id,
        total: i.acd_total
      }));
    },

    getStateColor(state) {
      switch (state) {
        case 'paid':
          return 'green';
        case 'unpaid':
          return 'red';
        default:
          return 'gray';
      }
    },

    async save() {
      this.loading = true;
      try {
        let payload = {
          ...this.invoice,
          invoice_ids: this.selectedInvoices.map(i => i.invoice_id),
          customer_id: this.selectedCustomer,
          invoice_name: this.invoice.invoice_name || this.generateInvoiceName(),
          invoice_items: this.invoice.invoice_items // Hinzufügen der individuellen Totals
        };

        await CustomersService.createConsolidatedInvoice(payload);
      } catch (err) {
        alert(err.message);
      } finally {
        this.loading = false;
        router.back();
      }
    },

    generateInvoiceName() {
      let quarterName = this.quarters.find((q) => q.value == this.selectedQuarter);
      let quarterText = quarterName && quarterName.text ? quarterName.text : '';

      let customer = this.getCustomers().find(c => c.customer_id === this.selectedCustomer);
      let customerName = customer ? customer.customer_name : 'Unknown';

      let year = this.invoice.invoice_start_date ? new Date(this.invoice.invoice_start_date).getFullYear() : new Date().getFullYear();

      return year + ' ' + quarterText + ' - ' + customerName;
    },

    async refresh() {
      try {
        this.loading = true;
        const response = (await CustomersService.getInvoicesForACD()).data;
        if (Array.isArray(response)) {
          this.invoices = response;
        } else {
          console.error('Unexpected response format from getInvoices');
          this.invoices = [];
        }
      } catch (err) {
        console.error('Error fetching invoices:', err);
        this.error = err.message;
        this.invoices = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>